import React from "react";
import LegalPage from "../../components/legal/LegalPage";

// Verbatim reproduction of https://www.tocahealth.com/terms (as published;
// entity naming and wording intentionally preserved , any revision to the
// legal text itself is owned by the legal team, not here).
const SECTIONS = [
  {
    id: "agreement",
    heading: "Agreement",
    body: (
      <>
        <p>
          The following terms constitute an agreement between you and Care
          Connection Networks, LLC, its subsidiaries and affiliates
          (collectively, the "Company" or "CCN" or "we" or "us"), the operator
          of www.careconnectionhealth.com and (collectively, the "Website").
          This Agreement governs your use of the Website, both as a visitor and
          a registered user as described below, and purchase, use and/or access
          to the CCN service and products (collectively, the "Service").
        </p>
        <p>
          By accessing or using the Website and the Service, you agree to be
          bound by the terms of this Agreement. To the extent you register on
          the Website as a registered user, then in addition to the terms that
          are applicable to all users of the site, the terms that apply only to
          registered users shall apply to you as well. To the extent you
          purchase products from the Website, the terms that apply to product
          purchase, payment, shipment and returns will apply to you as well.
        </p>
      </>
    ),
  },
  {
    id: "changes",
    heading: "Changes to Agreement",
    body: (
      <p>
        CCN may revise these terms of use at its sole discretion. Your use of
        the Website constitutes your agreement to such changes. CCN may change,
        modify, suspend, or discontinue any aspect of Service at any time. CCN
        may also limit certain features or restrict your access to parts or all
        of the Service without notice or liability. You have no interest,
        monetary or otherwise, in any feature or content contained in the
        Service covered in this Agreement.
      </p>
    ),
  },
  {
    id: "registered-users",
    heading: "Registered Users",
    body: (
      <p>
        To access certain parts of the Website and the Service you must become
        a registered user. To become a registered user and access the area on
        the Website reserved for registered users (the "Registered User Area"),
        the Company requires that you create a username and password as well as
        provide certain.
      </p>
    ),
  },
  {
    id: "acceptable-use",
    heading: "Acceptable and Lawful Use of the Website",
    body: (
      <>
        <p>
          Users shall not post or upload any information or other content on
          the Website that (a) is false, inaccurate or misleading; (b) is
          obscene or indecent; (c) infringes any copyright, patent, trademark,
          trade secret or other proprietary rights or rights of publicity or
          privacy of any party; or (d) is defamatory, libelous, threatening,
          abusive, hateful, or contains pornography. Users shall not interfere
          with other users use and enjoyment of Website (for example, by
          harassing, threatening or stalking another participant of a chat
          room, forum, seminar, or threaded message, including the use of
          expressions of bigotry, racism, hatred, or profanity). Users may not
          use the Website to conduct any activity that is illegal or violates
          the rights of others, provide instructional information about illegal
          activities, or promote physical harm or injury against any group or
          individual.
        </p>
        <p>
          All registered users represent and warrant that the information they
          provided when registering as a registered user, and all information
          that they subsequently provide, is true and accurate and not
          misleading.
        </p>
      </>
    ),
  },
  {
    id: "use-of-website",
    heading: "Use of Website",
    body: (
      <p>
        You may not use any automated means to access the Website, the Service
        or content or services provided on the Website for any purposes. You
        may not post content on the Website or as part of the Service that
        contains any viruses, Trojan horses, worms, time bombs, spiders, or
        other computer programming routines that are intended to damage,
        detrimentally interfere with, surreptitiously intercept or expropriate
        any system, data or personal information. You shall not attempt to make
        the Website or the Service unavailable through denial-of-service
        attacks or similar means. You shall not use contact information
        provided by registered users, or collect information about our
        registered users, to facilitate the sending of unsolicited bulk
        communications such as SPAM or SPIM or allow others use of your account
        to take such actions.
      </p>
    ),
  },
  {
    id: "non-commercial",
    heading: "Non-Commercial Use",
    body: (
      <p>
        The Website and the Service is for the personal use of individual
        registered users only and may not be used in connection with any
        commercial endeavors without the prior consent of CCN, organizations,
        companies, and/or businesses may register as such in our population
        management portal.
      </p>
    ),
  },
  {
    id: "password",
    heading: "Registered User Password and Login Identity",
    body: (
      <p>
        You are responsible for maintaining the confidentiality of your
        registered user password and login for the Website and the Service, and
        are fully responsible for all activities that occur under your password
        or account with or without your knowledge. If you knowingly provide
        your login and password information to another person, your registered
        user privileges to the Website and the Service may be suspended
        temporarily or terminated. You agree to immediately notify CCN of any
        unauthorized use of your password or login or any other breach of
        security.
      </p>
    ),
  },
  {
    id: "links",
    heading: "Links to Other Websites",
    body: (
      <p>
        The Website may contain links to other websites that are not under the
        control of CCN. The inclusion of any link does not imply endorsement by
        CCN of such website and CCN is not responsible for the content of such
        linked website.
      </p>
    ),
  },
  {
    id: "termination",
    heading: "Registered Usership Termination",
    body: (
      <p>
        You agree that the Company may, with or without cause, immediately
        terminate your CCN registered usership and access to the Registered
        User Area, the Website and the Service without prior notice. Without
        limiting the foregoing, the following may lead to a termination by the
        Company of a registered user's registered usership and use of the
        Website and the Service: (a) breaches or violations of this Agreement
        or other incorporated agreements or guidelines, (b) requests by law
        enforcement or other government agencies, (c) a request by you
        (self-initiated usership cancellation), (d) unexpected technical issues
        or problems, and (e) extended periods of inactivity. CCN has no
        obligation to maintain, store or transfer information or data that you
        have posted on or uploaded to the Registered User Area to you
      </p>
    ),
  },
  {
    id: "warranties",
    heading: "Disclaimer of Warranties",
    body: (
      <p>
        THE WEBSITE, THEIR APPLICABLE THE CONTENT AND SERVICES ARE PROVIDED ON
        AN "AS IS" AND "AS AVAILABLE" BASIS. CCN DOES NOT MAKE, AND DISCLAIMS
        ALL EXPRESS AND IMPLIED WARRANTIES AND REPRESENTATIONS, INCLUDING, BUT
        NOT LIMITED TO, ANY IMPLIED WARRANTY OF FITNESS FOR A PARTICULAR
        PURPOSE, WITH REGARD TO THE WEBSITE AND THE SERVICE, THE WEBSITE
        CONTENT, OR ANY ADVICE OR SERVICES PROVIDED THROUGH THE WEBSITE TO THE
        EXTENT PERMITTED BY LAW. CCN DOES NOT WARRANT THAT ACCESS TO THE
        WEBSITE, THEIR APPLICABLE CONTENT, OR THE SERVICES WILL BE
        UNINTERRUPTED OR ERROR-FREE OR THAT DEFECTS IN THE WEBSITE OR THE
        SERVICES WILL BE CORRECTED. THE ADVICE, RECOMMENDATIONS, INFORMATION,
        AND CONCLUSIONS POSTED OR EMAILED BY OTHER REGISTERED USERS OF THE
        WEBSITE ARE NOT IN ANY WAY VETTED, APPROVED OR ENDORSED BY CCN, AND YOU
        USE SUCH INFORMATION AT YOUR OWN RISK. NOT ALL PRODUCTS SOLD ON THIS
        WEBSITE HAVE WARRANTIES. WARRANTIES ARE LIMITED TO INDIVIDUAL PRODUCTS
        WHEN APPLICABLE. REFER TO THE PRODUCT FOR WARRANTY INFORMATION
      </p>
    ),
  },
  {
    id: "liability",
    heading: "Limitation of Liability",
    body: (
      <p>
        EXCEPT WHERE PROHIBITED BY LAW, UNDER NO CIRCUMSTANCES SHALL CCN BE
        LIABLE FOR ANY INDIRECT, PUNITIVE, INCIDENTAL, SPECIAL, OR
        CONSEQUENTIAL DAMAGES (EVEN IF IT HAS BEEN ADVISED OF THE POSSIBILITY
        OF SUCH DAMAGES) DUE TO YOUR USE OF THIS WEBSITE, THE SERVICES OR DUE
        TO YOUR RELIANCE ON ANY OF THE CONTENT CONTAINED OR THE SERVICES.
      </p>
    ),
  },
  {
    id: "indemnification",
    heading: "Indemnification",
    body: (
      <p>
        You agree to indemnify and hold harmless the Company, its officers,
        employees, agents, subsidiaries, affiliates and other partners, from
        and against any claims, actions or demands, liabilities and settlements
        including without limitation, reasonable legal and accounting fees,
        resulting from, or alleged to result from, your violation of this
        Agreement.
      </p>
    ),
  },
  {
    id: "international",
    heading: "International Users",
    body: (
      <p>
        CCN makes no claims that information on the Website is appropriate or
        may be used or downloaded outside of the United States. Personal
        information ("Information") that is submitted to this Website and the
        Service will be collected, processed, stored, disclosed and disposed of
        in accordance with applicable U.S. law and our Privacy Policy. If you
        are a non-U.S. user, you acknowledge and agree that the Company may
        collect and use your Information and disclose it to other entities
        outside your resident jurisdiction. In addition, such Information may
        be stored on servers located outside your resident jurisdiction. U.S.
        law may not provide the degree of protection for Information that is
        available in other countries. By providing us with your Information,
        you acknowledge that you consent to the transfer of such Information
        outside your resident jurisdiction as detailed in our Privacy Policy.
        If you do not consent to such transfer, you may not use this Website or
        the Service.
      </p>
    ),
  },
  {
    id: "notices",
    heading: "Registered User Notices",
    body: (
      <p>
        If you register as a registered user, you agree that CCN may send
        notices to you by email at the email address you provide when
        registering to become a registered user (or which you later update
        using the functionality of the Website or the Service)
      </p>
    ),
  },
  {
    id: "governing-law",
    heading: "Governing Law and Venue",
    body: (
      <p>
        This Agreement shall be governed by the laws of the state of Delaware
        and the applicable federal laws of the United States of America. All
        disputes arising under, or in any way connected with Services or use of
        the Website, shall be litigated exclusively in the state and federal
        courts residing in the state of Delaware, and in no other court or
        jurisdiction.
      </p>
    ),
  },
];

const TermsPage = () => (
  <LegalPage
    title="Terms of Use"
    updatedNote={"© 2024 Toca Health, Inc."}
    sections={SECTIONS}
    contact={
      <p>
        E-mail: <a href="mailto:sales@tocahealth.com">sales@tocahealth.com</a>
        <br />
        Phone: (818) 232-7221
      </p>
    }
  />
);

export default TermsPage;
